import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { AvatarProfileImageFragmentDoc } from '../../../../fragments.generated';
import { ChatDetailFragmentDoc } from './ChatDetailPage.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GroupChatOwnerUsersQueryVariables = Types.Exact<{
  input: Types.UserSelectionInput;
}>;


export type GroupChatOwnerUsersQuery = { __typename?: 'Query', GetUsersForUserSelection: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, userType: Types.UserType, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null, roles: Array<{ __typename?: 'Role', id: number, name: string }>, locations: Array<{ __typename?: 'Location', id: number, name: string }> }> };

export type UpdateChatSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateChatSettingsInput;
}>;


export type UpdateChatSettingsMutation = { __typename?: 'Mutation', updateChatSettings: { __typename?: 'ChatMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, chat?: { __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, viewerArchivedAt?: string | null, createdAt: string, title?: { __typename?: 'TranslationSet', en: string } | null, createdBy: { __typename?: 'Employee', id: number, name: string }, owners: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, userType: Types.UserType, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null, roles: Array<{ __typename?: 'Role', id: number, name: string }>, locations: Array<{ __typename?: 'Location', id: number, name: string }> }>, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, allLocations: boolean, allTrainees: boolean, allManagers: boolean, allAdmins: boolean, everyoneAtOrgOrBrand: boolean, daysAfterHire?: number | null, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number, user: { __typename?: 'Employee', id: number, name: string } }>, locationMemberships: Array<{ __typename?: 'UserSelectionLocation', id: number, location: { __typename?: 'Location', id: number, name: string } }>, roleMemberships: Array<{ __typename?: 'UserSelectionRole', id: number, role: { __typename?: 'Role', id: number, name: string } }>, locationGroupMemberships: Array<{ __typename?: 'UserSelectionLocationGroup', id: string, locationGroup: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } }>, roleGroupMemberships: Array<{ __typename?: 'UserSelectionRoleGroup', id: string, roleGroup: { __typename?: 'RoleGroup', id: string, name: string } }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, userType: Types.UserType, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null, roles: Array<{ __typename?: 'Role', id: number, name: string }>, locations: Array<{ __typename?: 'Location', id: number, name: string }> }> } | null } };


export const GroupChatOwnerUsersDocument = gql`
    query GroupChatOwnerUsers($input: UserSelectionInput!) {
  GetUsersForUserSelection(input: $input) {
    id
    name
    firstName
    deactivatedAt
    userType
    profileImage {
      ...AvatarProfileImage
    }
    roles {
      id
      name
    }
    locations {
      id
      name
    }
  }
}
    ${AvatarProfileImageFragmentDoc}`;

/**
 * __useGroupChatOwnerUsersQuery__
 *
 * To run a query within a React component, call `useGroupChatOwnerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupChatOwnerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupChatOwnerUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupChatOwnerUsersQuery(baseOptions: Apollo.QueryHookOptions<GroupChatOwnerUsersQuery, GroupChatOwnerUsersQueryVariables> & ({ variables: GroupChatOwnerUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupChatOwnerUsersQuery, GroupChatOwnerUsersQueryVariables>(GroupChatOwnerUsersDocument, options);
      }
export function useGroupChatOwnerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupChatOwnerUsersQuery, GroupChatOwnerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupChatOwnerUsersQuery, GroupChatOwnerUsersQueryVariables>(GroupChatOwnerUsersDocument, options);
        }
export type GroupChatOwnerUsersQueryHookResult = ReturnType<typeof useGroupChatOwnerUsersQuery>;
export type GroupChatOwnerUsersLazyQueryHookResult = ReturnType<typeof useGroupChatOwnerUsersLazyQuery>;
export type GroupChatOwnerUsersQueryResult = Apollo.QueryResult<GroupChatOwnerUsersQuery, GroupChatOwnerUsersQueryVariables>;
export const UpdateChatSettingsDocument = gql`
    mutation UpdateChatSettings($input: UpdateChatSettingsInput!) {
  updateChatSettings(input: $input) {
    success
    error {
      code
    }
    chat {
      ...ChatDetail
    }
  }
}
    ${ChatDetailFragmentDoc}`;
export type UpdateChatSettingsMutationFn = Apollo.MutationFunction<UpdateChatSettingsMutation, UpdateChatSettingsMutationVariables>;

/**
 * __useUpdateChatSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateChatSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatSettingsMutation, { data, loading, error }] = useUpdateChatSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChatSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChatSettingsMutation, UpdateChatSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChatSettingsMutation, UpdateChatSettingsMutationVariables>(UpdateChatSettingsDocument, options);
      }
export type UpdateChatSettingsMutationHookResult = ReturnType<typeof useUpdateChatSettingsMutation>;
export type UpdateChatSettingsMutationResult = Apollo.MutationResult<UpdateChatSettingsMutation>;
export type UpdateChatSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateChatSettingsMutation, UpdateChatSettingsMutationVariables>;